import React, { useEffect, useState } from 'react';
import { usePublicAdsStore } from '../../stores/useDataStore';
import AdCard from '../ads/AdCard';
import AdBanner from '../common/AdBanner';

const AdsWidget = () => {
  const ads = usePublicAdsStore((state) => state.ads);
  const isLoading = usePublicAdsStore((state) => state.isLoading);
  const fetchPublicAds = usePublicAdsStore((state) => state.fetchPublicAds);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    fetchPublicAds?.({ placement: 'adCard' });
  }, [fetchPublicAds]);

  const hasAds = Array.isArray(ads) && ads.length > 0;

  useEffect(() => {
    if (!ads || ads.length <= 1) return undefined;
    const timer = setInterval(() => {
      setActiveIndex((prev) => prev + 1);
    }, 6000);
    return () => clearInterval(timer);
  }, [ads]);

  useEffect(() => {
    if (activeIndex > 0 && (!ads || ads.length === 0)) {
      setActiveIndex(0);
    }
  }, [ads, activeIndex]);

  return (
    <div className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 p-4 rounded-lg shadow-md">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100">Publicidad</h3>
      </div>

      {isLoading && !hasAds ? (
        <div className="text-xs text-gray-500 dark:text-gray-400">Cargando anuncios...</div>
      ) : hasAds ? (
        <div className="relative h-72">
          {ads.map((ad, index) => {
            const isActive = index === activeIndex % ads.length;
            return (
              <div
                key={ad._id || index}
                className={`absolute inset-0 transition-opacity duration-700 ${
                  isActive ? 'opacity-100' : 'opacity-0 pointer-events-none'
                }`}
              >
                <AdCard ad={ad} />
              </div>
            );
          })}
        </div>
      ) : (
        <AdBanner />
      )}
    </div>
  );
};

export default AdsWidget;
